import { useMutation, useQuery } from "@tanstack/react-query";
import { useAlert } from "context/alert";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createHeaderFooterImage } from "services/headerFooterDetail";
import { getZoneList } from "../../redux/action/drop_list_action";
import Select from "react-select";
import {
  createProfilePicture,
  deleteProfilePicture,
  getEmployeeProfilePicture,
} from "services/profilePicture";
import { STALE_TIME } from "utils/constants";

const ProfilePicture = ({ onClose }) => {
  const { showAlert } = useAlert();
  const dispatch = useDispatch();

  const [headerChecked, setHeaderChecked] = useState(false);
  const [footerChecked, setFooterChecked] = useState(false);
  const [file, setFile] = useState(null);
  const [fileError, setFileError] = useState(false);
  const [fileData, setFileData] = useState("");
  const [selectedZoneId, setSelectedZoneId] = useState(null);
  const [zoneError, setZoneError] = useState(false);
  const [checkboxError, setCheckboxError] = useState(false);

  const jwtAuthreducer = useSelector((state) => state.jwtAuthreducer);
  // const { zone_list } = useSelector((state) => state.dropListReducer);

  // const _token =
  //   jwtAuthreducer?.token_values?.sub &&
  //   JSON.parse(jwtAuthreducer?.token_values?.sub?.replace(/'/g, '"'));

  const { mutate: addProfilePictureMutate } = useMutation(
    createProfilePicture,
    {
      onSuccess: () => {
        showAlert("Image uploaded successfully!", "success");
        onClose(true);
      },
      onError: () => {
        showAlert("Something went wrong!", "danger");
      },
    }
  );

  const { mutate: deleteProfilePictureMutate } = useMutation(
    deleteProfilePicture,
    {
      onSuccess: () => {
        showAlert("Delete image successfully!", "success");
        onClose(true);
      },
      onError: () => {
        showAlert("Something went wrong!", "danger");
      },
    }
  );

  const { data: profilePictureData } = useQuery(
    ["fetch-profile-picture", jwtAuthreducer?.user?.employee_code_id],
    () =>
      getEmployeeProfilePicture({
        employee_code_id: jwtAuthreducer?.user?.employee_code_id,
      }),
    {
      staleTime: STALE_TIME,
      onError: (error) => {
        console.error("Error fetching profile picture:", error);
      },
    }
  );

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    if (selectedFile) {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result;
        const base64Data = base64String.split(",")[1];
        console.log("base64Data", base64Data);
        setFileData(base64Data);
      };
      reader.readAsDataURL(selectedFile);
    }
    setFileError(!selectedFile);
  };

  const franchiseId = localStorage.getItem("franchise_id");

  const handleSubmit = (e) => {
    e.preventDefault();

    const hasCheckboxError = !headerChecked && !footerChecked;
    const hasFileError = !file;
    const hasZoneError = !selectedZoneId;

    setCheckboxError(hasCheckboxError);
    setFileError(hasFileError);
    setZoneError(hasZoneError);

    const payload = {
      employee_code_id: jwtAuthreducer.user.employee_code_id,
      file_name: file.name,
      file_path: file.name,
      franchise_id: franchiseId,
      is_active: true,
      created_by: jwtAuthreducer.user.employee_code_id,
      file_data: fileData,
    };

    if (profilePictureData?.data) {
      deleteProfilePictureMutate(jwtAuthreducer.user.employee_code_id, {
        onSuccess: () => {
          addProfilePictureMutate(payload);
        },
        onError: (error) => {
          console.error("Delete failed:", error);
        },
      });
    } else {
      addProfilePictureMutate(payload);
    }
  };

  useEffect(() => {
    dispatch(getZoneList());
  }, [dispatch]);

  const isPDF = (base64String) => {
    return base64String && base64String.startsWith("JVBERi0");
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="row mt-3">
        <div className="col-md-8">
          <label className="form-label">
            Upload Document <span className="text-danger">*</span>
          </label>
          <input
            type="file"
            className={`form-control ${fileError ? "is-invalid" : ""}`}
            onChange={handleFileChange}
            accept=".pdf,image/*"
          />
          {fileError && (
            <div className="text-danger mt-1">File is required.</div>
          )}
        </div>

        {profilePictureData?.data && (
          <div className="col-md-4 text-end">
            {isPDF(profilePictureData.data) ? (
              <object
                data={`data:application/pdf;base64,${profilePictureData.data}`}
                type="application/pdf"
                width="200"
                height="200"
                style={{
                  width: "200px",
                  height: "200px",
                  border: "1px solid #ddd",
                }}
              >
                <div
                  style={{
                    width: "200px",
                    height: "200px",
                    backgroundColor: "#f8f9fa",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "14px",
                    color: "#666",
                    border: "1px solid #ddd",
                  }}
                >
                  PDF Preview
                </div>
              </object>
            ) : (
              <img
                src={`data:image/jpeg;base64,${profilePictureData?.data}`}
                width="38"
                alt="User"
                title="User"
                style={{
                  width: "200px",
                  height: "200px",
                  objectFit: "cover",
                }}
              />
            )}
          </div>
        )}
      </div>
      <div className="mt-4">
        <button type="submit" className="btn btn-primary">
          Upload
        </button>
      </div>
    </form>
  );
};

export default ProfilePicture;

// import { useMutation } from "@tanstack/react-query";
// import { useAlert } from "context/alert";
// import { useEffect, useState, useRef } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { createHeaderFooterImage } from "services/headerFooterDetail";
// import { getZoneList } from "../../redux/action/drop_list_action";
// import Select from "react-select";
// import { createProfilePicture } from "services/profilePicture";

// const ProfilePicture = ({ onClose }) => {
//   const { showAlert } = useAlert();
//   const dispatch = useDispatch();

//   const [headerChecked, setHeaderChecked] = useState(false);
//   const [footerChecked, setFooterChecked] = useState(false);
//   const [file, setFile] = useState(null);
//   const [fileError, setFileError] = useState(false);
//   const [fileData, setFileData] = useState("");
//   const [selectedZoneId, setSelectedZoneId] = useState(null);
//   const [zoneError, setZoneError] = useState(false);
//   const [checkboxError, setCheckboxError] = useState(false);

//   // New states for preview and crop
//   const [imagePreview, setImagePreview] = useState(null);
//   const [showCropModal, setShowCropModal] = useState(false);
//   const [cropData, setCropData] = useState({
//     x: 0,
//     y: 0,
//     width: 200,
//     height: 200,
//   });
//   const [croppedImage, setCroppedImage] = useState(null);
//   const [originalImage, setOriginalImage] = useState(null);

//   const canvasRef = useRef(null);
//   const imageRef = useRef(null);

//   const jwtAuthreducer = useSelector((state) => state.jwtAuthreducer);
//   const { zone_list } = useSelector((state) => state.dropListReducer);

//   const _token =
//     jwtAuthreducer?.token_values?.sub &&
//     JSON.parse(jwtAuthreducer?.token_values?.sub?.replace(/'/g, '"'));

//   const { mutate: addProfilePictureMutate } = useMutation(
//     createProfilePicture,
//     {
//       onSuccess: () => {
//         showAlert("Image uploaded successfully!", "success");
//         onClose(true);
//       },
//       onError: () => {
//         showAlert("Something went wrong!", "danger");
//       },
//     }
//   );

//   const handleFileChange = (e) => {
//     const selectedFile = e.target.files[0];
//     setFile(selectedFile);

//     if (selectedFile) {
//       // Check if it's an image
//       if (selectedFile.type.startsWith("image/")) {
//         const reader = new FileReader();
//         reader.onload = () => {
//           const result = reader.result;
//           setOriginalImage(result);
//           setImagePreview(result);
//           setShowCropModal(true);
//         };
//         reader.readAsDataURL(selectedFile);
//       } else {
//         // For non-image files (like PDF)
//         const reader = new FileReader();
//         reader.onload = () => {
//           const base64String = reader.result;
//           const base64Data = base64String.split(",")[1];
//           setFileData(base64Data);
//         };
//         reader.readAsDataURL(selectedFile);
//       }
//     }
//     setFileError(!selectedFile);
//   };

//   const handleCropStart = (e) => {
//     const rect = imageRef.current.getBoundingClientRect();
//     const x = e.clientX - rect.left;
//     const y = e.clientY - rect.top;
//     setCropData({ ...cropData, x, y });
//   };

//   const cropImage = () => {
//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext("2d");
//     const image = imageRef.current;

//     canvas.width = cropData.width;
//     canvas.height = cropData.height;

//     ctx.drawImage(
//       image,
//       cropData.x,
//       cropData.y,
//       cropData.width,
//       cropData.height,
//       0,
//       0,
//       cropData.width,
//       cropData.height
//     );

//     const croppedDataUrl = canvas.toDataURL("image/jpeg", 0.9);
//     setCroppedImage(croppedDataUrl);

//     // Convert to base64 for upload
//     const base64Data = croppedDataUrl.split(",")[1];
//     setFileData(base64Data);

//     setShowCropModal(false);
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     const hasCheckboxError = !headerChecked && !footerChecked;
//     const hasFileError = !file;
//     const hasZoneError = !selectedZoneId;

//     setCheckboxError(hasCheckboxError);
//     setFileError(hasFileError);
//     setZoneError(hasZoneError);

//     if (hasCheckboxError || hasFileError || hasZoneError) return;

//     const payload = {
//       employee_code_id: jwtAuthreducer.user.employee_code_id,
//       file_name: file.name,
//       file_path: file.name,
//       franchise_id: selectedZoneId || Number(_token.zone_id),
//       is_active: true,
//       created_by: jwtAuthreducer.user.employee_code_id,
//       file_data: fileData,
//     };

//     addProfilePictureMutate(payload);
//   };

//   const resetImage = () => {
//     setFile(null);
//     setImagePreview(null);
//     setCroppedImage(null);
//     setFileData("");
//     setOriginalImage(null);
//   };

//   useEffect(() => {
//     dispatch(getZoneList());
//   }, [dispatch]);

//   return (
//     <div>
//       {/* Crop Modal */}
//       {showCropModal && (
//         <div
//           className="modal fade show"
//           style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
//           tabIndex="-1"
//         >
//           <div className="modal-dialog modal-lg">
//             <div className="modal-content">
//               <div className="modal-header">
//                 <h5 className="modal-title">Crop Your Image</h5>
//                 <button
//                   type="button"
//                   className="btn-close"
//                   onClick={() => setShowCropModal(false)}
//                 ></button>
//               </div>
//               <div className="modal-body text-center">
//                 <div className="position-relative d-inline-block">
//                   <img
//                     ref={imageRef}
//                     src={originalImage}
//                     alt="Original"
//                     style={{
//                       maxWidth: "100%",
//                       maxHeight: "400px",
//                       cursor: "crosshair",
//                     }}
//                     onMouseDown={handleCropStart}
//                   />
//                   <div
//                     style={{
//                       position: "absolute",
//                       left: cropData.x,
//                       top: cropData.y,
//                       width: cropData.width,
//                       height: cropData.height,
//                       border: "2px dashed #007bff",
//                       backgroundColor: "rgba(0, 123, 255, 0.1)",
//                       pointerEvents: "none",
//                     }}
//                   ></div>
//                 </div>

//                 <div className="mt-3">
//                   <label>Crop Size:</label>
//                   <div className="row">
//                     <div className="col-6">
//                       <input
//                         type="range"
//                         className="form-range"
//                         min="100"
//                         max="400"
//                         value={cropData.width}
//                         onChange={(e) =>
//                           setCropData({
//                             ...cropData,
//                             width: parseInt(e.target.value),
//                             height: parseInt(e.target.value),
//                           })
//                         }
//                       />
//                       <small>
//                         Size: {cropData.width}x{cropData.height}
//                       </small>
//                     </div>
//                   </div>
//                 </div>

//                 <canvas ref={canvasRef} style={{ display: "none" }}></canvas>
//               </div>
//               <div className="modal-footer">
//                 <button
//                   type="button"
//                   className="btn btn-secondary"
//                   onClick={() => setShowCropModal(false)}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-primary"
//                   onClick={cropImage}
//                 >
//                   Crop Image
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       <form onSubmit={handleSubmit}>
//         <div className="row mt-3">
//           <div className="col-12">
//             <label className="form-label">
//               Upload Document <span className="text-danger">*</span>
//             </label>
//             <input
//               type="file"
//               className={`form-control ${fileError ? "is-invalid" : ""}`}
//               onChange={handleFileChange}
//               accept=".pdf,image/*"
//             />
//             {fileError && (
//               <div className="text-danger mt-1">File is required.</div>
//             )}
//           </div>
//         </div>

//         {/* Image Preview Section */}
//         {(imagePreview || croppedImage) && (
//           <div className="row mt-3">
//             <div className="col-12">
//               <label className="form-label">Preview:</label>
//               <div className="d-flex align-items-center flex-wrap gap-3">
//                 {croppedImage ? (
//                   <div className="text-center">
//                     <div className="mb-2">
//                       <img
//                         src={croppedImage}
//                         alt="Cropped Preview"
//                         style={{
//                           width: "150px",
//                           height: "150px",
//                           objectFit: "cover",
//                           border: "2px solid #ddd",
//                           borderRadius: "8px",
//                         }}
//                       />
//                     </div>
//                     <small className="text-muted">Final Image</small>
//                   </div>
//                 ) : (
//                   <div className="text-center">
//                     <div className="mb-2">
//                       <img
//                         src={imagePreview}
//                         alt="Original Preview"
//                         style={{
//                           width: "150px",
//                           height: "150px",
//                           objectFit: "cover",
//                           border: "2px solid #ddd",
//                           borderRadius: "8px",
//                         }}
//                       />
//                     </div>
//                     <small className="text-muted">Original</small>
//                   </div>
//                 )}

//                 <div className="d-flex flex-column gap-2">
//                   {originalImage && (
//                     <button
//                       type="button"
//                       className="btn btn-outline-primary btn-sm"
//                       onClick={() => setShowCropModal(true)}
//                     >
//                       {croppedImage ? "Re-crop Image" : "Crop Image"}
//                     </button>
//                   )}
//                   <button
//                     type="button"
//                     className="btn btn-outline-danger btn-sm"
//                     onClick={resetImage}
//                   >
//                     Remove Image
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}

//         <div className="mt-4">
//           <button type="submit" className="btn btn-primary me-2">
//             Upload
//           </button>
//           <button
//             type="button"
//             className="btn btn-secondary"
//             onClick={() => onClose(false)}
//           >
//             Cancel
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default ProfilePicture;
